<!-- <div #mainContainer class="container-fluid px-0">
  <ng-content></ng-content>
</div> -->

<div id="main-wrapper" class="container-fluid px-0 h-100 d-flex flex-column" #mainContainer>
  <main id="content-wrapper" class="d-flex flex-grow-1 flex-column">
    <ng-content></ng-content>
  </main>
  <app-footer></app-footer>
</div>